import React from 'react';
import { buildUrl } from 'utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const StatisticBox = ({ id, count, label, link, color }) => {
  return (
    <Link to={buildUrl(link)}>
      <Box
        height={100}
        display="flex"
        borderRadius="5px"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        style={{ backgroundColor: color }}
      >
        <Typography>
          <Box
            fontSize={56}
            display="block"
            component="span"
            lineHeight="60px"
            fontWeight="bold"
            color="common.white"
            data-cy={`statistic-box-count-${id}`}
          >
            {count}
          </Box>
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="row">
          <Typography>
            <Box
              fontSize={13}
              component="span"
              lineHeight="15px"
              fontWeight="bold"
              color="common.white"
              data-cy={`statistic-box-label-${id}`}
            >
              {label}
            </Box>
          </Typography>
          <ArrowRightIcon
            data-cy={`statistic-box-icon-${id}`}
            sx={{ color: 'common.white', fontSize: 24 }}
          />
        </Box>
      </Box>
    </Link>
  );
};

StatisticBox.propTypes = {
  id: PropTypes.string,
  count: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default StatisticBox;
